// extracted by mini-css-extract-plugin
module.exports = {"Chip":"chip_Chip__jVF8n","Action":"chip_Action__lHl0C","Icon":"chip_Icon__7TwPM"};